<template>
  <vs-row>
    <vs-col vs-w="12">
      <vx-card>

        <vs-row class="contratto-data mt-10">
          <vs-col class="text-center" vs-justify="center" vs-align="center" vs-w="12">

            <vx-card>

              <vs-row class="contratto-header m-top-10">
                <vs-col class="text-right" vs-offset="6" vs-justify="right" vs-w="3">
                      <vs-button class="no-pointer-event" type="flat" :color="stato[selected['stato']['stato']]"> {{selected['stato']['stato']}}</vs-button>
                </vs-col>
                <vs-col class="p-0" vs-align="right" vs-w="1">
                  <vs-button @click="modificaContratto(selected, $event)" :disabled="!$acl.check('responsabile') && this.utente_id != selected['id_creatore']" icon-pack="feather" icon="icon-edit" color="primary" radius type="border" align="right" size="large"></vs-button>
                </vs-col>
                <vs-col class="p-0" vs-align="right" vs-w="1">
                  <vs-button @click="eliminaContratto(selected['index_contratto'], $event)" :disabled="!$acl.check('responsabile') && this.utente_id != selected['id_creatore']" icon-pack="feather" icon="icon-trash" color="danger" radius type="border" align="right" size="large"></vs-button>
                </vs-col>
                <vs-col class="p-0" vs-align="right" vs-w="1">
                  <vs-button @click="generaPDF($event)" icon-pack="feather" icon="icon-download" color="warning" radius type="border" align="right" size="large"></vs-button>
                </vs-col>
              </vs-row>

              <vs-row class="contratto-data">
                <vs-col class="text-right" vs-justify="right" vs-align="left" vs-w="10">
                  <div class="mt-2">
                    <vs-row class="mt-4">
                      <p class="mr-8">Contratto in Data :</p>
                      <h6 class="mr-8"> {{ $tariffe.formatDate(selected['data_emissione']) }} </h6>
                      <h6 v-if="selected['persona_esposta']">  Persona esposta  </h6>
                    </vs-row>
                    <vs-row class="mt-2">
                      <p class="mr-8">Operatore :</p>
                      <h6 class="mr-8"> {{ selected['creatore']['nome'] }} </h6>
                      <p ><feather-icon icon="MailIcon" svgClasses="h-4 w-4"></feather-icon>{{ ' '+selected['creatore']['email'] }}</p>
                    </vs-row>
                    <vs-row class="mt-4">
                      <p class="mr-8">Metodo di pagamento :</p>
                      <h6 class="mr-8"> {{ selected['metodo_pagamento']['nome'] }} </h6>
                      <p class="mr-8">Cliente :</p>
                      <h6 class="jst-r"> {{ [selected['preventivo']['contatto_azienda']['azienda']['tipo_azienda'],selected['preventivo']['contatto_azienda']['azienda']['ragione_sociale']].filter(e => e).join(',  ') }} </h6>
                    </vs-row>
                  </div>
                </vs-col>
              </vs-row>

              <vs-row v-if="selected['metodo_pagamento']['nome'] == 'Addebito in c/c'" class="contratto-addebito">
                <vs-col class="text-left" vs-justify="left" vs-align="left" vs-w="5">
                  <div class="mt-6">
                    <vs-row v-if="selected['iban']">
                      <p class="mt-4">Iban :</p>
                      <h6> {{ selected['iban'] }} </h6>
                    </vs-row>
                    <vs-row v-if="selected['indirizzo']">
                      <p class="mt-4">Indirizzo :</p>
                      <h6> {{ selected['indirizzo'] }} </h6>
                    </vs-row>
                    <vs-row v-if="selected['cap']">
                      <p class="mt-4">Cap :</p>
                      <h6> {{ selected['cap'] }} </h6>
                    </vs-row>
                    <vs-row v-if="selected['provincia']">
                      <p class="mt-4">Provincia :</p>
                      <h6> {{ selected['provincia'] }} </h6>
                    </vs-row>
                    <vs-row v-if="selected['localita']">
                      <p class="mt-4">Località :</p>
                      <h6> {{ selected['localita'] }} </h6>
                    </vs-row>
                  </div>
                </vs-col>
                <vs-col class="text-right" vs-offset="2" vs-justify="right" vs-align="right" vs-w="5">
                  <div class="mt-6">
                    <vs-row v-if="selected['cognome']">
                      <p class="mt-4">Cognome :</p>
                      <h6> {{ selected['cognome'] }} </h6>
                    </vs-row>
                    <vs-row v-if="selected['nome']">
                      <p class="mt-4">Nome :</p>
                      <h6> {{ selected['nome'] }} </h6>
                    </vs-row>
                    <vs-row v-if="selected['codice_fiscale']">
                      <p class="mt-4">Codice fiscale :</p>
                      <h6> {{ selected['codice_fiscale'] }} </h6>
                    </vs-row>
                    <vs-row v-if="selected['partita_iva']">
                      <p class="mt-4">Partita iva :</p>
                      <h6> {{ selected['partita_iva'] }} </h6>
                    </vs-row>
                  </div>
                </vs-col>
              </vs-row>

            </vx-card>

          </vs-col>
        </vs-row>

        <vs-row class="preventivo-voci mt-10">
          <vs-col class="text-center" vs-justify="center" vs-align="center" vs-w="12">
              <vs-table hoverFlat :data="selected['preventivo']['voci']">
                  <template slot="thead">
                    <vs-th :key="i" v-for="(e, i) in ['Descrizione', 'Tipologia servizio', 'Quantità', 'Preventivato']">{{e}}</vs-th>
                  </template>
                  <template>
                      <vs-tr v-for="(tr, index) in selected['preventivo']['voci']" :key="index">
                          <vs-td :key="0" :data="tr.tariffa_applicata.nome">{{ tr.tariffa_applicata.nome }}</vs-td>
                          <vs-td :key="1" :data="tr.tariffa_applicata.tipo_servizio">{{ tr.tariffa_applicata.tipo_servizio }}</vs-td>
                          <vs-td :key="2" :data="tr.quantita">{{ tr.quantita }}</vs-td>
                          <vs-td :key="3" :data="tr.preventivato">{{ (tr.preventivato).toPrecision(4) }}</vs-td>
                          <!-- <vs-td :key="4" :data="tr.preventivato">{{ ((tr.tariffa_applicata.importo*tr.quantita)*100 - 100).toPrecision(4) }}</vs-td> -->
                      </vs-tr>
                  </template>
              </vs-table>
              <vs-table hoverFlat class="w-4/5 ml-auto mt-2" :data="preventivato">
                  <vs-tr>
                      <vs-th>Totale</vs-th>
                      <vs-td>{{ (this.preventivato).toPrecision(4) }} €</vs-td>
                  </vs-tr>
              </vs-table>
          </vs-col>
        </vs-row>
      </vx-card>
    </vs-col>
  </vs-row>
</template>

<script>


export default {
  data() {
    return {
      componentKey: 0,
      preventivato: 0,
      utente_nome: "",
      utente_id: "",
      stato: {
        'Accettato': 'success',
        'Aperto': 'warning',
        'Rifiutato': 'danger',
        'Inviato': 'warning',
        'Consegnato': 'dark',
        'Revisionato': 'warning'
      },
    }
  },
  props: {
    selected: Object,
    active: Boolean
  },
  mounted() {
    this.calcolaPreventivo(this.selected['preventivo']['voci'])
    if (localStorage.utente_nome) {
      this.utente_nome = localStorage.utente_nome
    }
    if (localStorage.utente_id) {
      this.utente_id = localStorage.utente_id
    }
  },
  methods: {
    generaPDF(ev) {
      this.$emit('pdf', { obj: this.selected, templates: this.selected.preventivo.voci[0].tariffa_applicata.templates.map( e => ({'nuovo_nome': e.template_stampa.nuovo_nome})) })
      ev.stopPropagation()
    },
    modificaContratto(contratto, ev) {
      this.$emit('modifica-contratto', contratto)
      ev.stopPropagation()
    },
    eliminaContratto(idx, ev) {
      this.$emit('elimina-contratto', idx)
      ev.stopPropagation()
    },
    calcolaPreventivo(voci) {
      let preventivato_ = 0
      voci.forEach( (e) => {
        if (+e.quantita > 0 && +e.preventivato > 0) {
          preventivato_ += (+e.preventivato * +e.quantita)
        }
      })
      this.preventivato = +preventivato_
    },
  },
}
</script>
